import { render, staticRenderFns } from "./onoff-switch.vue?vue&type=template&id=50f667f9&scoped=true&"
import script from "./onoff-switch.vue?vue&type=script&lang=ts&"
export * from "./onoff-switch.vue?vue&type=script&lang=ts&"
import style0 from "./onoff-switch.vue?vue&type=style&index=0&id=50f667f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f667f9",
  null
  
)

export default component.exports